import { SceneManager } from 'Domain/Scene/Manager/SceneManager'
import { retrieveBlob } from 'Application/LocalStorage/IndexedDBHandler'
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import { setPhase, INIT_PHASES } from 'Domain/Scene/Manager/InitializationOrchestrator';
import { initStats, statsUpdate } from 'Domain/Scene/Utils/StatsManager';
import { disposeComposers } from 'Domain/Mesh/Handler/Composer';


/*****************************************************************
 *  3D Container Manager
 * ***************************************************************/

let currentContainer = null
let rafId = null
let active = false

export const setViewerContainer = (el) => {
  currentContainer = el
  if (el) {
    const renderer = threeEngine.getRenderer()
    if (renderer?.domElement && renderer.domElement.parentNode !== el) {
      el.appendChild(renderer.domElement)
    }
  }
}

/**
 * Manage 3D container
 * @param {*} containerElement
 * @returns
 */
export const containerElement = async (containerElement, props) => {
  if (active) return () => {}

  let manager
  active = true
  currentContainer = containerElement

  /**
   *  threeJS Scene instanciation
   */
  const value = await retrieveBlob(props);

  threeEngine.setProjectId(props.project.ref.sk)
  manager = await SceneManager(
    containerElement,
    value,
    {
      hash: props.project.hash,
      format: props.project.format
    }
  );

  setPhase(INIT_PHASES.UI_READY)

  await initStats(threeEngine.getRenderer())

  /**
   * Loop on requestAnimationFrame
   */
  const animate = () => {
    if (manager !== undefined && currentContainer) {
      manager.update(currentContainer)
    }
    statsUpdate()
    rafId = window.requestAnimationFrame(animate)
  }

  rafId = requestAnimationFrame(animate)

  setPhase(INIT_PHASES.COMPLETE)

  return () => {
    active = false
    currentContainer = null
    if (rafId) {
      cancelAnimationFrame(rafId)
      rafId = null
    }
    disposeComposers()
    threeEngine.dispose()
  }
}
